const rentMinPriceValues = [
    {
        value: '0',
        en: 'Min Price',
        th: 'ราคาขั้นต่ำ',
        cn: '最低价格',
        ru: 'Мин. цена',
        de: 'Minimaler Preis',
        fr: 'Prix minimum',
        it: 'Prezzo minimo',
        ja: '最低価格',
        ko: '최저 가격',
        es: 'Precio mínimo',
        tr: 'Minimum Fiyat',
        he: 'מחיר מינימלי',
        ar: 'أقل سعر'
    },
    '3000', '5000', '7500', '10000', '12500', '15000', '17500', '20000', '22500',
    '25000', '30000', '35000', '40000', '50000', '60000', '70000', '80000', '90000',
    '100000', '125000', '150000', '175000', '200000', '250000', '300000', '400000',
    '500000', '750000', '1000000'
];

const languages = ['en', 'th', 'cn', 'ru', 'de', 'fr', 'it', 'ja', 'ko', 'es', 'tr', 'he', 'ar'];

const getLocale = (lang) => {
    switch (lang) {
        case 'cn': return 'zh-CN';
        case 'fr': return 'fr-FR';
        case 'de': return 'de-DE';
        case 'tr': return 'tr-TR';
        case 'it': return 'it-IT';
        case 'es': return 'es-ES';
        default:   return lang;
    }
};

export const rentMinPrices = languages.reduce((acc, lang) => {
    acc[lang] = rentMinPriceValues.map(item => {
        if (typeof item === 'object') {
            return { value: item.value, nom: item[lang] };
        }

        let formattedNom = Number(item).toLocaleString(getLocale(lang));
        if (lang === 'fr') {
            formattedNom = formattedNom.replace(/\u202f/g, ' ');
        }

        return { value: item, nom: formattedNom };
    });
    return acc;
}, {});